(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hz-coll-card"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__hzcCard) return;
    window.__hzcCard = true;

    const mainImg = (card) => card.querySelector('.hzc-card__img--main');

    const remember = (img) => {
      if (!img.__hzcOrig) {
        img.__hzcOrig = { src: img.getAttribute('src'), srcset: img.getAttribute('srcset'), sizes: img.getAttribute('sizes') };
      }
    };

    const show = (card, swatch) => {
      const img = mainImg(card);
      const url = swatch.dataset.cardImage;
      if (!img || !url) return;
      remember(img);
      const media = img.parentElement;
      if (swatch.dataset.thumb) media.style.backgroundImage = 'url(' + swatch.dataset.thumb + ')';
      media.style.backgroundSize = 'cover';
      media.style.backgroundPosition = 'center';
      const pre = new Image();
      pre.onload = () => {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.setAttribute('src', url);
      };
      pre.src = url;
      card.classList.add('is-swatched');
    };

    const restore = (card) => {
      const img = mainImg(card);
      if (!img || !img.__hzcOrig) return;
      const o = img.__hzcOrig;
      img.setAttribute('src', o.src);
      if (o.srcset) img.setAttribute('srcset', o.srcset);
      if (o.sizes) img.setAttribute('sizes', o.sizes);
      img.parentElement.style.backgroundImage = '';
      card.classList.remove('is-swatched');
    };

    const mark = (card, swatch) => {
      card.querySelectorAll('.hzc-swatch[aria-current="true"]').forEach((s) => {
        if (s !== swatch) s.removeAttribute('aria-current');
      });
      swatch.setAttribute('aria-current', 'true');
    };

    const canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;

    if (canHover) {
      document.addEventListener('mouseover', (e) => {
        const sw = e.target instanceof Element ? e.target.closest('.hzc-swatch') : null;
        if (!sw || sw.contains(/** @type {Node} */ (e.relatedTarget))) return;
        const card = sw.closest('.hzc-card');
        if (!card) return;
        show(card, sw);
        mark(card, sw);
      });
      document.addEventListener('mouseout', (e) => {
        const sw = e.target instanceof Element ? e.target.closest('.hzc-swatch') : null;
        if (!sw || sw.contains(/** @type {Node} */ (e.relatedTarget))) return;
        const card = sw.closest('.hzc-card');
        if (!card || card.__hzcPicked) return;
        restore(card);
        sw.removeAttribute('aria-current');
      });
    }

    document.addEventListener(
      'click',
      (e) => {
        const sw = e.target instanceof Element ? e.target.closest('.hzc-swatch') : null;
        if (!sw) return;
        e.preventDefault();
        e.stopPropagation();
        const card = sw.closest('.hzc-card');
        if (!card) return;
        card.__hzcPicked = true;
        const link = card.querySelector('.hzc-card__link');
        if (link) link.setAttribute('href', sw.getAttribute('href'));
        show(card, sw);
        mark(card, sw);
      },
      true
    );

    const warm = (card) => {
      if (card.__hzcWarm) return;
      card.__hzcWarm = true;
      card.querySelectorAll('.hzc-swatch[data-card-image]').forEach((s) => {
        const i = new Image();
        i.src = s.dataset.cardImage;
      });
    };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((en) => {
            if (en.isIntersecting) {
              warm(/** @type {Element} */ (en.target));
              io.unobserve(en.target);
            }
          });
        },
        { rootMargin: '300px' }
      );
      const watch = () =>
        document.querySelectorAll('.hzc-card:not([data-hzc-io])').forEach((c) => {
          c.setAttribute('data-hzc-io', '1');
          if (c.querySelector('.hzc-swatch[data-card-image]')) io.observe(c);
        });
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
      else watch();
      let queued = false;
      new MutationObserver(() => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => {
          queued = false;
          watch();
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
